module.exports = __webpack_public_path__ + "static/media/llamar3.a2e2b95c.png";